/**
 * Spread onto inputs that must not trigger password managers / autofill.
 * `autoComplete="off"` alone is often ignored by browser extensions.
 */
/**
 * Password managers keep out (1Password, LastPass, Bitwarden, Dashlane). Every Input, Textarea and
 * combobox search has these unless it's a sign-in field (components/ui/input.tsx).
 */
export const passwordManagerIgnoreProps = {
  'data-1p-ignore': true,
  'data-lpignore': 'true',
  'data-bwignore': true,
  'data-form-type': 'other',
} as const;

export const noPasswordManagerProps = {
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: false,
  ...passwordManagerIgnoreProps,
} as const;
